// extracted by mini-css-extract-plugin
export const nextUpButtonContainer = "next-up-button-module--next-up-button-container--OddH9";
export const nextUpButton = "next-up-button-module--next-up-button--3s7wV";
export const textItalic = "next-up-button-module--text-italic--3vKQl";
export const textBold = "next-up-button-module--text-bold--1s5sH";
export const textContainer = "next-up-button-module--text-container--3RV3r";
export const countdownPlayIcon = "next-up-button-module--countdown-play-icon--1nNVs";
export const playIcon = "next-up-button-module--play-icon--2T9xZ";
export const countdown = "next-up-button-module--countdown--j6pTf";